import { CogIcon } from "@heroicons/react/24/solid/index.js";
import { OutlinedButton } from "../../../UI/Button/OutlinedButton.tsx";
import { useNavigate } from "react-router-dom";
import { StudyPlanScreenPath } from "./StudyPlanScreen.tsx";
import { useTranslation } from "react-i18next";
import { useFreezableWeeks } from "./useFreezableWeeks.ts";
import { useMyFrozenWeeks } from "./useMyFrozenWeeks.ts";

export function StudyPlanButton() {
  const navigate = useNavigate();
  const { t } = useTranslation("lessonPlanManagementButton");
  const { freezableWeeks, loading: loadingFreezableWeeks } =
    useFreezableWeeks();
  const { frozenWeeks, loading: loadingFrozenWeeks } = useMyFrozenWeeks();

  if (loadingFreezableWeeks || loadingFrozenWeeks) return null;

  if ((freezableWeeks?.weeks.length ?? 0) <= 0 && frozenWeeks.length <= 0)
    return null;

  return (
    <>
      <div>
        <OutlinedButton
          iconLeft={<CogIcon className={"w-6"} />}
          label={t("label")}
          onClick={() => navigate(StudyPlanScreenPath)}
        />
      </div>
    </>
  );
}
